<template>
	<div class="ReCardKBPostNest mt-2">
		<card class="mt-3" v-if="!bIsEdit">
			<div class="">			
				<div class="row mx-0 align-items-center mb-3">
					<div class="tStatus-select mr-3">
						<el-select
							class="col-md px-0 select-primary"
							v-model="topic_value" 
							clearable
							filterable
							placeholder="Выбрать тему поста"
							size="large"
							@change="filterFAQ()"
						>
							<el-option
								class="select-primary"
								v-for="tg in masThemesTags"
								:key="tg.value"
								:label="tg.label"
								:value="tg.id"
							>
							</el-option>
						</el-select>
					</div>						
				</div>
				<div v-if="this.objFAQ && Object.keys(this.objFAQ).length > 0" class="row">
					<div v-for="(group, index) in objFAQ" class="col-lg-6 col-md-12">
						<template v-for="tg in masThemesTags">
							<h6 v-if="tg.id == index" class="mb-2 mt-4">{{tg.label}}</h6>
						</template>
						<template v-for="faq in group">
							<ReCardKBPost :objFAQ="faq" :kb_group="kb_group"/>
						</template>
					</div>
				</div>
			</div>
			<!-- <Pagination class="mt-3" :class="[{'': parseInt(masFAQ_total) > 0}, {'d-none': parseInt(masFAQ_total) < 1}]"
				:type="'info'" 
				:total="parseInt(masFAQ_total)" 
				:perPage="parseInt(50)"
				:value="parseInt(typeof objGetParams.p == 'undefined' ? 1:objGetParams.p)"
				:pClick="pClick">
			</Pagination> -->

		</card>
		
		
	</div>
</template>

<script>
import { Select, Option, Button } from 'element-ui';
import ReCardKBPost from 'src/our_components/knowledgebase/ReCardKBPost.vue';
// import Pagination from 'src/our_components/RePagination';

export default {
	name: "ReCardKBPostNest",
	components: {
		[Option.name]: Option,
        [Select.name]: Select,
        [Button.name]: Button,
		ReCardKBPost,
		// Pagination,
	},
	props: {
		bIsEdit:{
			type: Boolean,
			default: false,
		},
		kb_group:{
			type: String,
			default: 'KB_MAIN',
		}
	},
	data() {
		return {
			ver: 1,
			objFAQ: {},
			// objFAQ: [],
			masFAQ_total: 0,
			topic_value: '',
			masThemesTags: [],
			count2page: 50,
		};
	},
	computed: {},
	methods: {
		getFAQ(topic){
			let filter = {};
			filter = {"theme_id":topic};

			this.$GVO.ApiCall(`${this.kb_group}.GET`,{flt: {...filter, 'c2p':this.count2page, act: 1, grouped:true} })
			.then((objApi) => {
				if(objApi.success === true){
					// console.log('objApi.data',typeof objApi.data);
					if(Object.keys(objApi.data).length > 0){
						this.objFAQ = objApi.data;
						// console.log('this.objFAQ',this.objFAQ);
						if(objApi.total!=undefined) { this.masFAQ_total=objApi.total; }
					}
				}else{
					this.objFAQ = {};
					this.masFAQ_total=0;
				}
			}).catch(errorObjApi => {this.objFAQ = {}; this.masFAQ_total=0; console.error(errorObjApi);});
		},
		filterFAQ(){
			this.objFAQ=[];
			this.getFAQ(this.topic_value);
		},
		gotoFAQPage(id){
			this.$router.push({path: '/data/knowledgebase/posts/id/'+id});
		}
		// pClick(e){
		// 	this.objGetParams['p'] = parseInt(e);
		// 	this.getFAQ();
		// },

	},
	mounted() {
		let themes_cat = `CAT_${this.kb_group}_THEMES`;
		this.$GVO.LoadCatPromise(themes_cat)
		.then((objApi) => {
			if(objApi=== true){
				for (let i = 0; i < this.$GVO.cats[themes_cat].length; i++) {
					const element = this.$GVO.cats[themes_cat][i];
					if(element.act==1) this.masThemesTags.push({'value':element.val,'label':element.val, 'id':element.id}); //вопрос val или id ?
				}
			}
		})
		.catch(errorObjApi => {console.error(errorObjApi); });

		this.getFAQ();
	}
};
</script>

<style scoped>


</style>
